import { liteClient } from 'algoliasearch/lite';

const hasAlgoliaConfig =
  window.ALGOLIA_SEARCH_APP_ID && window.ALGOLIA_SEARCH_API_KEY;

export const algoliaClient = hasAlgoliaConfig
  ? liteClient(window.ALGOLIA_SEARCH_APP_ID, window.ALGOLIA_SEARCH_API_KEY)
  : null;

export const searchClient = hasAlgoliaConfig
  ? {
      ...algoliaClient,
      search(requests) {
        if (requests.every(({ params, query }) => !params.query && !query)) {
          return Promise.resolve({
            results: requests.map(() => ({
              hits: [],
              nbHits: 0,
              nbPages: 0,
              page: 0,
              processingTimeMS: 0,
              hitsPerPage: 0,
              exhaustiveNbHits: false,
              query: '',
              params: '',
            })),
          });
        }

        // check to see if we're search helpdesk only via the within=help URL
        // param
        const searchParams = new URLSearchParams(window.location.search);

        if (searchParams.get('within') === 'help') {
          requests = requests.map((request) => ({
            ...request,
            params: {
              ...request.params,
              facets: ['*'],
              facetFilters: [
                [
                  'objectClassName:ZNZ\\Content\\HelpArticle',
                  'objectClassName:ZNZ\\Content\\HelpCategory',
                ],
              ],
            },
          }));
        }

        return algoliaClient.search(requests);
      },
    }
  : null;
